
import Vue from "vue";
import { NewAdminBulkUploadApi } from "@/api";
import { Gateway, BulkGatewaysTransactionRow } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import BaseFileDropArea from "@/components/BaseFileDropArea.vue";
import GatewayBulkUploadList from "./components/GatewayBulkUploadList.vue";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";

const api = NewAdminBulkUploadApi();

export type DataType = {
  afterUploading: boolean;
  uploadLoading: boolean;
  commitLoading: boolean;
  transactionId: number;
  transactionRows: BulkGatewaysTransactionRow[];
  filterStatus: string;
  checked: boolean;
};

export default Vue.extend({
  name: "GatewayUploadScreen",

  components: {
    BaseChuiGaki,
    TheTemplate,
    BaseSubmitButton,
    BaseCancelButton,
    BaseFileDropArea,
    GatewayBulkUploadList,
  },

  data() {
    return {
      afterUploading: false,
      uploadLoading: false,
      commitLoading: false,
      transactionId: "",
      transactionRows: [] as BulkGatewaysTransactionRow[],
      filterStatus: "",
      checked: false,
    };
  },

  computed: {
    loading(): boolean {
      return this.uploadLoading || this.commitLoading;
    },

    hasErrorRow(): boolean {
      return this.transactionRows.some((r: BulkGatewaysTransactionRow) => {
        return r.status !== "登録可能";
      });
    },

    canSubmit(): boolean {
      return this.afterUploading && !this.loading && !this.hasErrorRow;
    },

    filteredRows(): BulkGatewaysTransactionRow[] {
      return this.transactionRows.filter((r: BulkGatewaysTransactionRow) => {
        return (
          r.status === this.filterStatus ||
          this.filterStatus === "" ||
          this.filterStatus === undefined
        );
      });
    },
  },

  methods: {
    async fileSelected(event: Event): Promise<void> {
      const target = event.target as HTMLInputElement;
      if (target.files == undefined) {
        return;
      }
      this.handleBlob(target.files);
    },

    async handleBlob(files: FileList): Promise<void> {
      if (files == undefined) {
        return;
      }
      const file = files[0];

      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }

      this.$setLoading(true);
      this.uploadLoading = true;
      const { data, err } = await api.bulkUploadGateways(companyId, file);
      if (err != null) {
        this.$setLoading(false);
        this.uploadLoading = false;
        this.$handleApiError(err, () => {
          this.handleBlob(files);
        });
        return;
      }

      this.transactionId = data?.transactionId!!;
      this.transactionRows = data?.rows!!;
      this.uploadLoading = false;
      this.afterUploading = true;

      this.$setLoading(false);
    },

    async commit(): Promise<void> {
      if (!this.canSubmit) return;
      if (this.loading || this.checked) return;

      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      this.commitLoading = true;

      const { err } = await api.commitGateways(companyId, this.transactionId);
      if (err != null) {
        this.$setLoading(false);
        this.uploadLoading = false;
        this.$handleApiError(err, this.commit);
        return;
      }

      this.checked = true;
      this.$setLoading(false);
      this.commitLoading = false;

      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-gateways",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    back(): void {
      if (this.afterUploading) {
        this.afterUploading = false;
        return;
      }
      this.$router.push("/company/gateways");
    },

    updateFilterStatus(status?: string): void {
      if (status === undefined) {
        this.filterStatus = "";
        return;
      }
      this.filterStatus = status;
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
